<template>
    <section class="modal-mask superadmin-modal modal-add-recipients-via-textarea">
        <div class="modal-mask-inner" @click="closeOpenModal"></div>
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <Title size="input-label" title="Enter email addresses" />
                    <Title size="input-subtext" title="Use only addresses of users in Edurio’s database. Use comma to separate emails." />

                    <textarea v-model="emailsString" />
                </div>
                <div class="modal-footer">
                    <CustomButton buttonType="quote" buttonText="Separate by comma"
                                  :isDisabled="inputEmpty" :callback="() => separateByComma()"/>
                    <CustomButton buttonType="add" :isDisabled="inputEmpty" :callback="returnEmails" />

                    <CustomButton buttonType="close" :callback="closeOpenModal"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomButton from "@/components/superadmin/ux/CustomButton";
    import Title from "@/components/superadmin/ux/components/Title";

    import SuperadminMixins from "@/mixins/super-admin";

    export default {
        name: "AddRecipients",
        props: ["emails", "selectExistingEmails", "addNewEmails"],
        components: {
            Title,
            CustomButton
        },
        mixins: [SuperadminMixins],
        computed: {
            inputEmpty() {
                return !this.emailsString
            }
        },
        data() {
            return {
                emailsString: '',
            }
        },
        methods: {
            returnEmails() {
                this.triggerModalCallback(this.emailsString)
            }
        }
    }
</script>

<style lang="scss">
    .superadmin-modal.modal-add-recipients-via-textarea {
        .modal-container {
            width: 100%;
            max-width: 600px;
        }
    }
</style>